'use client';

// P29.20 client subcomponent for the marketing footer's contact CTA so the
// otherwise-Server-Component footer can still fire a Plausible event.

import { trackEvent } from '@/lib/analytics/plausible';

type Props = { href: string; label: string };

export function FooterCtaButton({ href, label }: Props) {
  return (
    <a
      href={href}
      data-testid="marketing-footer-cta"
      onClick={() => trackEvent('CTA Click', { variant: 'footer-cta' })}
      className="inline-flex items-center rounded-md border border-emerald-700 px-3 py-1 text-xs font-medium text-emerald-700 hover:bg-emerald-50"
    >
      {label}
    </a>
  );
}
